import { render, staticRenderFns } from "./TechnicianMRList.vue?vue&type=template&id=04d85016"
import script from "./TechnicianMRList.vue?vue&type=script&lang=ts"
export * from "./TechnicianMRList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports